import React from 'react'
import PropTypes from 'prop-types'
import { Map, List } from 'immutable'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'
import { formatCurrency, listPipeFind } from '@aytm/lib/common/func'
import Select from '@aytm/lib/rfd-ui/components/basic/select'
import CreditCardEntry from '@aytm/lib/rfd-ui/components/payment/credit-card-entry'

import '@aytm/lib/rfd-ui/styles/payment/select-payment.scss'

export const NEW_PAYMENT_METHOD_VALUE = Map({
  id: null,
  newPaymentMethod: true
})

export default class SelectPayment extends PureDataComponent {
  static propTypes = {
    width: PropTypes.number,
    placeholder: PropTypes.string,
    options: PropTypes.instanceOf(List).isRequired,
    opened: PropTypes.bool,
    value: PropTypes.any,
    onSelect: PropTypes.func,
    isEmpty: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    filterOptions: PropTypes.bool,
    error: PropTypes.bool,
    drop: PropTypes.string,
    showSelected: PropTypes.bool,
    newCreditCardBy: PropTypes.instanceOf(Map)
  }

  constructor(props) {
    super(props)
    this.paymentOptionToSelectOption = this.paymentOptionToSelectOption.bind(this)
    this.updateSelectOptions = this.updateSelectOptions.bind(this)
    this.updateValue = this.updateValue.bind(this)
    this.onSelect = this.onSelect.bind(this)
    this.state = {
      selectOptions: List(),
      newPaymentMethodForm: false,
      value: null
    }
  }

  paymentOptionToSelectOption(option = Map()) {
    const titleSpan = `<span class="rfd-ui-select-payment-title">${option.get('title')}</span>`
    switch (option.getIn(['type', 'id'])) {
      case 'credit_card': {
        const lastFourSpan = option.has('last_four')
          ? ` <span class='rfd-ui-select-payment-option-note'>&nbsp(***${option.get('last_four')})</span>`
          : ''
        const cardTypeSpan = option.has('card_type')
          ? ` <span class='credit-card-icon ${option.get('card_type').replace(/\s+/g, '-')}'></span>`
          : ''
        return Map({
          text: `${titleSpan}${lastFourSpan}${cardTypeSpan}`,
          value: option
        })
      }
      default: {
        const amountSpan = option.get('amount')
          ? `<span class='rfd-ui-select-payment-option-note'>: $${formatCurrency(option.get('amount') / 100)}</span>`
          : ''
        return Map({
          text: `${titleSpan}${amountSpan}`,
          value: option
        })
      }
    }
  }

  updateSelectOptions(options = this.props.options, value = this.props.value) {
    this.setState(
      {
        selectOptions: List.isList(options)
          ? null == this.props.newCreditCardBy
            ? options.map(o => this.paymentOptionToSelectOption(o))
            : options
                .map(o => this.paymentOptionToSelectOption(o))
                .push(
                  Map({
                    text: "<span class='rfd-ui-select-payment-title'>New credit card</span> <span class='credit-card-icon stripe'/>",
                    value: NEW_PAYMENT_METHOD_VALUE,
                    newPaymentMethod: true
                  })
                )
          : List()
      },
      () => {
        this.updateValue(value)
      }
    )
  }

  updateValue(to = this.props.value) {
    const updateToOptionValue = listPipeFind(
      [
        () => (NEW_PAYMENT_METHOD_VALUE == to ? NEW_PAYMENT_METHOD_VALUE : null),
        () => (NEW_PAYMENT_METHOD_VALUE.get('id') == to ? NEW_PAYMENT_METHOD_VALUE : null),
        () => (null == to && this.state.selectOptions.count() ? this.state.selectOptions.getIn([0, 'value']) : null),
        () => (null == to && !this.state.selectOptions.count() ? NEW_PAYMENT_METHOD_VALUE : null),
        () =>
          'string' == typeof to
            ? this.state.selectOptions.find(o => to == o.getIn(['value', 'id']), this, Map()).get('value')
            : null,
        () => this.state.selectOptions.find(o => to == o.get('value'), this, Map()).get('value')
      ],
      null
    )
    if (updateToOptionValue != this.state.value) {
      this.setState({
        value: updateToOptionValue,
        newPaymentMethodForm: updateToOptionValue == NEW_PAYMENT_METHOD_VALUE
      })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    super.UNSAFE_componentWillReceiveProps(nextProps)
    if (nextProps.options != this.props.options) {
      this.updateSelectOptions(nextProps.options, nextProps.value)
    }
    if (nextProps.value != this.props.value) {
      this.updateValue(nextProps.value)
    }
  }

  componentDidMount() {
    super.componentDidMount()
    this.updateSelectOptions()
  }

  onSelect(option) {
    this.setState({ newPaymentMethodForm: Boolean(option.get('newPaymentMethod')) })
    const { onSelect } = this.props
    if ('function' == typeof onSelect) return onSelect(option.get('value') || Map())
    return false
  }

  renderStripeNewPaymentMethodForm(config) {
    return config.has('key') ? (
      <CreditCardEntry
        stripeKey={config.get('key')}
        email={config.get('email')}
        title={config.get('title')}
        onSave={config.get('save')}
        testId="select-payment-add-card"
      />
    ) : null
  }

  renderNewPaymentMethodForm() {
    const { newCreditCardBy, width } = this.props
    if (!Map.isMap(newCreditCardBy)) return null

    return (
      <div className="rfd-ui-select-payment-new-payment" style={{ width: width }}>
        <div className="rfd-ui-select-payment-new-payment-inner">
          {(() => {
            switch (newCreditCardBy.get('service')) {
              case 'stripe':
                return this.renderStripeNewPaymentMethodForm(newCreditCardBy)
              default:
                return null
            }
          })()}
        </div>
      </div>
    )
  }

  render() {
    const { width, placeholder, opened, filterOptions, error, isEmpty, showSelected, drop } = this.props
    const { selectOptions, newPaymentMethodForm, value } = this.state

    return (
      <div className="rfd-ui-select-payment">
        <Select
          width={width}
          placeholder={placeholder}
          options={selectOptions}
          opened={opened}
          value={value}
          onSelect={this.onSelect}
          filterOptions={filterOptions}
          error={error}
          isEmpty={isEmpty}
          drop={drop}
          showSelected={showSelected}
          smallHeight={true}
        />
        {newPaymentMethodForm && this.renderNewPaymentMethodForm()}
      </div>
    )
  }
}
